import API from "../../..";
import { useQueryWrapper } from "../../wrappers";
import { getRoomsByOwnerIdKey } from "../room-query-keys";

export function useQueryGetRoomsByOwnerId(enabled: boolean, ownerId?: string) {
  const { isLoading, data, isError } = useQueryWrapper({
    queryKey: getRoomsByOwnerIdKey(ownerId ?? ""),
    queryFn: () => API.Rooms.getByOwnerIdRooms(ownerId),
    enabled,
  });
  return {
    isLoading,
    rooms: data || [],
    isError,
  };
}
